<template>
  <TitledCardBase :title="$t('component.pagenotfound.title')">
    <img src="@/assets/images/404.png" alt="" />
  </TitledCardBase>
</template>

<script>
import TitledCardBase from "@/components/shared/TitledCardBase";
export default {
  name: "PageNotFound",
  components: { TitledCardBase }
};
</script>

<style scoped></style>
